<div class="container mx-auto p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Assinaturas</h1>

  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>

  <div class="flex justify-between items-center">
    <div>
      <button pButton type="button" class="btn btn-primary btn-md" (click)="create()">
        <i class="pi pi-plus mr-2"></i>
        <span>Novo</span>
      </button>
    </div>
  </div>

  <p-table [value]="assinaturas" class="w-full mt-4">
    <ng-template pTemplate="header">
      <tr>
        <th class="p-2 border-b text-left">Empresa ID</th>
        <th class="p-2 border-b text-left">Schema</th>
        <th class="p-2 border-b text-left">Empresa</th>
        <th class="p-2 border-b text-left">Plano</th>
        <th class="p-2 border-b text-left">Status</th>
        <th class="p-2 border-b text-left">Aquisição</th>
        <th class="p-2 border-b text-left">Vencimento</th>
        <th class="p-2 border-b text-left">Dias</th>
        <th class="p-2 border-b text-left">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-a>
      <tr>
        <td class="p-2 border-b">{{ a.empresaId || a.id }}</td>
        <td class="p-2 border-b">{{ a.schemaName }}</td>
        <td class="p-2 border-b">{{ a.nomeEmpresa || '-' }}</td>
        <td class="p-2 border-b">{{ a.planoAssinatura || '-' }}</td>
        <td class="p-2 border-b">
          <ng-container *ngIf="a.statusAssinatura; else unknownStatus">
            <span *ngIf="a.statusAssinatura === 'ATIVA'" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Ativa</span>
            <span *ngIf="a.statusAssinatura === 'TRIAL'" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-blue-100 text-blue-800">Trial</span>
            <span *ngIf="a.statusAssinatura === 'VENCIDA'" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-800">Vencida</span>
            <span *ngIf="a.statusAssinatura === 'BLOQUEADA'" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">Bloqueada</span>
            <span *ngIf="a.statusAssinatura === 'SUSPENSA'" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-orange-100 text-orange-800">Suspensa</span>
            <span *ngIf="a.statusAssinatura === 'CANCELADA'" class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-800">Cancelada</span>
          </ng-container>
          <ng-template #unknownStatus>
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-gray-100 text-gray-800">-</span>
          </ng-template>
        </td>

        <td class="p-2 border-b">{{ a.dataAquisicao | date : 'dd/MM/yyyy' }}</td>
        <td class="p-2 border-b">{{ a.dataVencimento | date : 'dd/MM/yyyy' }}</td>
        <td class="p-2 border-b">{{ a.diasRestantes ?? '-' }}</td>

        <td class="p-2 border-b">
          <div class="button-group">
            <button pButton type="button" class="btn btn-md p-button-text text-gray-700" title="Ver detalhes" (click)="view(a)">
              <i class="pi pi-eye"></i>
            </button>

            <button pButton type="button" class="btn btn-md p-button-text text-gray-700" title="Editar" (click)="edit(a)">
              <i class="pi pi-pencil"></i>
            </button>

            <button pButton type="button" class="btn btn-md p-button-text text-gray-700" title="Renovar" (click)="renovar(a)">
              <i class="pi pi-refresh"></i>
            </button>

            <button pButton type="button" class="btn btn-md p-button-text" [ngClass]="a.bloqueadoPorAssinatura ? 'text-red-600' : 'text-gray-700'" [title]="a.bloqueadoPorAssinatura ? 'Assinatura bloqueada' : 'Cancelar assinatura'" (click)="confirmarCancelar(a)">
              <i class="pi pi-ban" [ngClass]="a.bloqueadoPorAssinatura ? 'text-red-600' : 'text-gray-700'"></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
